<template>
    <div>
        <div class="container">
            <div v-if="LoginErrorMsg" class="mb-5 pb-4 d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <ErrorMessage :errorNotification="errorNotification" />
            </div>
            <h1 class="title pb-3 mb-3 mt-3 mt-lg-0 mt-xl-0">Confirm Password Reset</h1>
            <div id="divContainer"></div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue'
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import gigyaWebSDK from '@/gigyaWebSDK'

    const errorNotification = ref('')
    const LoginErrorMsg = ref(false)

    function displayLoginErrorMsg(errorMsg) {
        LoginErrorMsg.value = true
        errorNotification.value = errorMsg
    }

    onMounted(() => {
        gigyaWebSDK.accounts.showScreenSet({
            screenSet: 'PasswordReset',
            containerID: "divContainer",
            startScreen: "gigya-reset-password-screen"
        })

        window.onPwdResetConfirmedHook = function (response) {
            if (response.errorCode === 0 || response.errorCode === "0") {
                const params = { screenSet: 'PasswordReset', containerID: "divContainer" }
                gigyaWebSDK.accounts.hideScreenSet(params)
                window.location.assign("/en-gb/sign-in")
            } else if (response.errorCode === 403025 || response.errorCode === "403025") {
                displayLoginErrorMsg("The verification link has expired.")
            } else {
                displayLoginErrorMsg("An error occured. Please try again.")
            }
        }
    })
</script>

<style lang="scss" scoped>
.title {
  @media screen and (max-width: 767px) and (min-width: 0px) {
    font-size: 24px;
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    font-size: 26px;
  }

  @media screen and (min-width: 992px) {
    font-size: 30px;
  }
}
</style>
